import { memo, useCallback, forwardRef, useMemo, useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import GridManageColumnsModal from '../containers/Watchlist/GridManageColumnsModal';
import noDataImg from '../assets/icons/nodata.svg';
import { useDispatch } from 'react-redux';
import { useDebounce } from '../hooks';
import { handleSelectingGivenRows, updateColumnProfileOnGridDestroy, getDecryptLocalStorage, setEncryptLocalStorage, bIsProd } from '../utils/global_functions';
import { updateArrDraggedColumns } from '../redux/actions/columnActions';

const noRowsTemplateString = `
    <div className='zero-state-alerts zero-state-alerts-md text-center p-2'>
        <div className='d-flex flex-column justify-content-center align-items-center'>
            <div className='icon-64 mrgauto icon-nodata mb-3'>
                <img width="64" height="64" src=${noDataImg} />
            </div>
            <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
            <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
        </div>
    </div>
`;


const BzMasterAgGrid = forwardRef(({
    gridKey,
    selectionColumnDef,
    gridProfileType = null,
    handleHeaderColumnClick,
    onGridPreDestroyed,
    isFirstDataRendered,
    suppressRowHoverHighlight = false,
    tooltipInteraction = false,
    onRowClicked,
    isShowEmptyGrid = true,
    pagination = false,
    isCompress = false,
    rowClassRules, onCellDoubleClicked, defaultColProps,// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices : action to take when a cell double clicked
    onBodyScrollEnd, rowBuffer, onRowGroupOpened, id, onBodyScroll, isFirstRowSelected = true, groupDefaultExpanded = false,
    isRowMaster, gridDetailCellRenderer, gridDetailCellRendererParams, navigateToNextCell, onRowSelected, isMasterDetail, onGridReady, onRowDragEnd, arrColumnData, arrRowData, rowHeight, getRowStyle, style, className, isSuppressMenu, getRowId, rowSelection, detailRowAutoHeight, onCellClicked, isExternalFilterPresent, doesExternalFilterPass, rowClass, onRowDataUpdated, suppressColumnVirtualisation = true }, ref
) => {//Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings

    // Maaz A: For Master Detail it is necessary to add expandCell key with blank value in row data.
    // expandCell = '';
    const dispatch = useDispatch();

    const [show, setShow] = useState(false);




    const defaultColDef = {
        ...defaultColProps,
        //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
        //This will supress the moving of columns by mouse pointer
        suppressMovable: bIsProd(), //true makes all columsn not movable by drag false makes all columns movable
        //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End
        sortable: true,
        resizable: true,
        suppressHeaderMenuButton: true, // this will hide the menu button in columns ** new version change
        menuTabs: ['filterMenuTab'],
        cellDataType: false,
        filterParams: {
            buttons: ['reset'],
        },
        flex: 1
        // there are three tabs i.e 'filterMenuTab','generalMenuTab' & columnsMenuTab
    };



    const autoSizeStrategy = useMemo(() => {
        return {
            type: 'fitCellContents'
        };
    }, []);

    const handleFilterReset = useCallback((event) => {
        event?.preventDefault();
        event?.stopPropagation();
        ref?.current?.api.setFilterModel(null);
    }, [ref]);

    // AutoFill all ag grid column on inital render
    const onFirstDataRendered = useCallback((params) => {
        //below line of code addeds click fucntionality to filter icon to every grid header column so on lcick user can clear filter
        // document.querySelectorAll(".ag-filter-icon").forEach((icon) => {
        //     icon.addEventListener('click', (event) => handleFilterReset(event, params));
        // });
        if (isFirstDataRendered) {
            isFirstDataRendered(params);
        }
        // params.api.sizeColumnsToFit();
        //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
        if (isFirstRowSelected) {
            const firstRowNode = params?.api?.getDisplayedRowAtIndex(0);
            if (firstRowNode) {
                handleSelectingGivenRows(params, null, null, [firstRowNode]);
                const arrColumnsNode = params?.api?.getColumnDefs();
                if (arrColumnsNode?.length > 0) {
                    params?.api?.setFocusedCell(0, arrColumnsNode[1]?.field);

                } else { }
            } else { }
        } else { }
        //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
        if (isMasterDetail) {
            const objThirdColumn = [params.api.getColumns()[1]];
            // params.api.autoSizeAllColumns();
            params.api.autoSizeColumns(objThirdColumn, true);
            //for row detailing
            setTimeout(function () {
                params?.api?.getDisplayedRowAtIndex(0)?.setExpanded(false);
            }, 0);
        } else {
            const objFirstColumn = [params.api.getColumns()[0]];
            params.api.autoSizeColumns(objFirstColumn, true);
        }
    }, [isMasterDetail, isFirstRowSelected, isFirstDataRendered]);

    useEffect(() => {
        if (arrRowData && !isCompress) {
            setTimeout(() => {
                ref?.current?.api?.autoSizeAllColumns(false);
            }, 1500);
        }
    }, [arrRowData, ref, isCompress]);

    // Vinit R - 10-07-2024 -- Add zero state for AG grid -- Start
    useEffect(() => {
        if (show == false && ref?.current?.api?.getDisplayedRowCount() > 0 && isShowEmptyGrid) {
            setShow(true);
        }
    }, [isShowEmptyGrid, ref, show]);
    // Vinit R - 10-07-2024 -- Add zero state for AG grid -- End





    const navigateToNextRow = useCallback((params) => {

        const previousCell = params.previousCellPosition;
        let nextRowIndex, renderedRowCount;
        let activeSelectedRow = ref?.current?.api?.getSelectedNodes()[0]?.rowIndex;
        switch (params.key) {
            case "ArrowDown":
                let nodeSelectDown = ref?.current?.api?.getDisplayedRowAtIndex(activeSelectedRow + 1);
                if (nodeSelectDown) {
                    nextRowIndex = activeSelectedRow + 1;
                    let nodeDeselectDown = ref?.current?.api?.getDisplayedRowAtIndex(nextRowIndex - 1);
                    handleSelectingGivenRows(params, null, null, [nodeDeselectDown], false);
                    handleSelectingGivenRows(params, null, null, [nodeSelectDown], true);
                } else {
                    return;
                }

                if (nextRowIndex < -1) {
                    return null;
                } else {
                    return {
                        rowIndex: nextRowIndex,
                        column: previousCell.column,
                    };
                }
            case "ArrowUp":
                activeSelectedRow = ref?.current?.api?.getSelectedNodes()[0]?.rowIndex;
                let nodeSelectUp = ref?.current?.api?.getDisplayedRowAtIndex(activeSelectedRow - 1);
                if (nodeSelectUp) {
                    nextRowIndex = activeSelectedRow - 1;
                    let nodeDeselectUp = ref?.current?.api?.getDisplayedRowAtIndex(activeSelectedRow);
                    handleSelectingGivenRows(params, null, null, [nodeSelectUp], true);
                    handleSelectingGivenRows(params, null, null, [nodeDeselectUp], false);
                } else {
                    return;
                }
                renderedRowCount = ref.current.api.getDisplayedRowCount();
                if (nextRowIndex >= renderedRowCount) {
                    return null;
                } else {
                    return {
                        rowIndex: nextRowIndex,
                        column: previousCell.column,
                    };
                }

            default:
                break;
        }
        if (navigateToNextCell) {
            navigateToNextCell(params);
        }
    }, [navigateToNextCell, ref]);


    // K Hari:23-01-2025: persisting the filters-start
    // Save the grid state securely using encryption
    const saveGridState = useCallback(() => {
        if (!ref.current?.api) return;
        const filterState = ref.current.api.getFilterModel();
        const columnState = ref.current.api.getColumnState();
        setEncryptLocalStorage(`${gridKey}_filterState`, JSON.stringify(filterState));
        setEncryptLocalStorage(`${gridKey}_columnState`, JSON.stringify(columnState));
    }, [gridKey, ref]);

    // Restore the grid state securely by decrypting
    const restoreGridState = useCallback(() => {
        if (!ref.current?.api) return;
        const encryptedFilterState = localStorage.getItem(`${gridKey}_filterState`);
        const encryptedColumnState = localStorage.getItem(`${gridKey}_columnState`);
        if (encryptedFilterState) {
            const filterState = getDecryptLocalStorage(encryptedFilterState);
            ref.current.api.setFilterModel(filterState);
        }
        if (encryptedColumnState) {
            const columnState = getDecryptLocalStorage(encryptedColumnState);
            ref.current.api.applyColumnState({
                state: columnState,
                applyOrder: true,
            });
        }
    }, [gridKey, ref]);


    const handleColumnRearrange = useCallback((event) => {
        saveGridState(event);
        useDebounce(() => {
            dispatch(updateArrDraggedColumns({ viewType: gridProfileType, cols: ref?.current?.api?.getColumnDefs() }));
        }, 500);
    }, [gridProfileType, ref, saveGridState, dispatch]);

    // Clear the grid state
    const clearGridState = useCallback(() => {
        if (!ref.current?.api) return;
        ref.current.api.setFilterModel(null);
        ref.current.api.resetColumnState();
    }, [ref]);

    const gridReady = useCallback((params) => {
        onGridReady && onGridReady(params);
        ref.current = params;
        restoreGridState();
    }, [onGridReady, ref, restoreGridState]);

    // Cleanup function to clear state on unmount
    useEffect(() => {
        return () => {
            localStorage.removeItem(`${gridKey}_filterState`);
            localStorage.removeItem(`${gridKey}_columnState`);
            clearGridState();
        };
    }, [gridKey, clearGridState]);

    // K Hari:23-01-2025: persisting the filters-end




    const onGridGetsDestroyed = useCallback((event) => {
        onGridPreDestroyed && onGridPreDestroyed(event);
        // HariK: commented after discussion with ameersha as this function is being called on distroy and changing the columns sequence
        if (!bIsProd()) {
            updateColumnProfileOnGridDestroy(event); // onGrid destruction this function will be called to save column profile
        }
    }, [onGridPreDestroyed]);


    return (<>
        <GridManageColumnsModal />
        <div style={style} className={className} id={id}>
            <AgGridReact
                animateRows={false}
                key={gridKey}
                onFilterChanged={saveGridState}
                selectionColumnDef={selectionColumnDef}
                // this will run on colums moving 
                onColumnMoved={handleColumnRearrange}
                //onDragStopped={handleColumnRearrange} // this will run on resizing columsn also
                pagination={pagination}
                masterDetail={isMasterDetail ? true : false}
                onGridReady={gridReady}
                rowData={arrRowData?.length > 0 ? arrRowData : []}
                // Vinit R - 10-07-2024 -- Add zero state for AG grid -- Start
                overlayNoRowsTemplate={!show ? "<span></span>" : noRowsTemplateString}
                // Vinit R - 10-07-2024 -- Add zero state for AG grid -- End
                columnDefs={arrColumnData}
                detailCellRenderer={gridDetailCellRenderer}
                detailCellRendererParams={gridDetailCellRendererParams}
                rowHeight={rowHeight}
                ref={ref}
                getRowStyle={getRowStyle}
                defaultColDef={defaultColDef}
                onFirstDataRendered={onFirstDataRendered}
                rowDragManaged={true}
                onRowDragEnd={onRowDragEnd}
                cacheQuickFilter={true}
                getRowId={getRowId}
                suppressMenuHide={isSuppressMenu}
                rowSelection={rowSelection}
                suppressColumnVirtualisation={suppressColumnVirtualisation}
                icons={{
                    sortAscending: '<div class="icon-14 icon-sort-up icon-grey" />',
                    sortDescending: '<div class="icon-14 icon-sort-down icon-grey" />',
                    sortUnSort: '<div class="icon-14 icon-sort icon-grey " />',
                    filter: '<div class="icon-12 icon-dark icon-sort-hamburger ms-2"/>'
                }}
                groupDefaultExpanded={groupDefaultExpanded}
                // suppressRowClickSelection={suppressRowClickSelection}
                detailRowAutoHeight={detailRowAutoHeight}
                navigateToNextCell={navigateToNextRow}
                onRowSelected={onRowSelected}
                isRowMaster={isRowMaster}
                onBodyScrollEnd={onBodyScrollEnd}
                rowBuffer={rowBuffer ? rowBuffer : 10}
                onBodyScroll={onBodyScroll}
                headerHeight={40}
                onCellClicked={onCellClicked}
                suppressContextMenu={true}
                isExternalFilterPresent={isExternalFilterPresent}
                doesExternalFilterPass={doesExternalFilterPass}
                onRowGroupOpened={onRowGroupOpened}
                // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices : action to take when a cell double clicked
                onCellDoubleClicked={onCellDoubleClicked}
                //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                rowClass={rowClass}
                rowClassRules={rowClassRules}
                onRowDataUpdated={onRowDataUpdated}
                suppressDragLeaveHidesColumns={true}
                // function that runs on row click when selection type is single
                onRowClicked={onRowClicked}
                autoSizeStrategy={autoSizeStrategy}
                tooltipShowDelay={100}
                tooltipHideDelay={100000}
                tooltipInteraction={tooltipInteraction}
                suppressRowHoverHighlight={suppressRowHoverHighlight}
                onGridPreDestroyed={onGridGetsDestroyed}
                onModelChange={handleHeaderColumnClick} />
        </div>
    </>);
});

export default memo(BzMasterAgGrid);